<template>
   <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M204-129q-30.94 0-52.97-22.03Q129-173.06 129-204v-552q0-30.94 22.03-52.97Q173.06-831 204-831h238.5v702H204Zm313.5 0v-351H831v276q0 30.94-22.03 52.97Q786.94-129 756-129H517.5Zm0-426v-276H756q30.94 0 52.97 22.03Q831-786.94 831-756v201H517.5Z"/></svg>
</template>
